import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as userAction from "../../../redux/actions/userAction";
import ReportCredentialCount from "../component/reportCredentialCount";
import { useLocation, useNavigate } from "react-router-dom";
import { CREDENTIAL_LOOKUP } from "../../../constant/routeContant";
import * as reportAction from "../../../redux/actions/reportAction";
import Loader from "../../../library/common/Loader";
import { ORG_ID, API_STATUS } from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";

function ReportCredentialCountConatiner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const PAGE_SIZES = 100;

  const NavigateToLookup = () => {
    navigate(CREDENTIAL_LOOKUP);
  };
  const getLookupCredentialReportData = useSelector(
    (state) => state.getLookupCredentialReportData,
  );
  const allGroups = useSelector((state) => state.searchAllGroup);
  const isLoading =
    allGroups.isLoading || getLookupCredentialReportData.isLoading;
  const [sendEmail, setSendEmail] = useState(false);

  const getCredentialListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }

    dispatch(reportAction.getLookupCredentialReport(data));
  };
  useEffect(() => {
    if (
      getLookupCredentialReportData?.status === API_STATUS.SUCCESS &&
      sendEmail
    ) {
      toast("Credentials has been sent to registered email ID");
    }
  }, [getLookupCredentialReportData]);
  const getLookupCredentialReports = (
    groupId,
    credentialTabId,
    startDate,
    endDate,
    divisionId,
    page1,
    isSendMail,
  ) => {
    
    const defaultDatas = {
      page: page1,
      pageSize: PAGE_SIZES,
      groupId: groupId ? groupId : 0,
      orgId: parseInt(ORG_ID()),
      tabId: parseInt(credentialTabId),
      startDate: startDate ? startDate : "",
      endDate: endDate ? endDate : "",
      divisionId: divisionId ? divisionId : 0,
      isSendMail: isSendMail,
    };
    dispatch(reportAction.getLookupCredentialReport(defaultDatas));
  };

  function handleAllGroupSearch(serachText, divisionId, alldivision) {
    dispatch(userAction.searchAllGroup(serachText, divisionId, alldivision));
  }

  const showLoader = useSelector(
    (state) =>
      state?.getCredentialReportData?.isLoading ||
      state?.getLookupCredentialReportData.isLoading,
  );

  const CredentialReportData = useSelector(
    (state) => state.getCredentialReportData,
  );

  const getCredentialReports = (data) => {
    dispatch(reportAction.getCredentialReport(data));
  };
  const clearDtaReports = () => {
    dispatch(reportAction.getLookupCredentialReportClear());
  };
  useEffect(() => {
    const initialGroupId = location?.state?.groupId
      ? location.state.groupId
      : 0;
    getCredentialReports({ groupId: initialGroupId });
  }, []);

  return (
    <>
      {showLoader && <Loader />}
      <ReportCredentialCount
        CredentialReportData={CredentialReportData}
        NavigateToLookup={NavigateToLookup}
        userGroups={allGroups?.data}
        getCredentialReports={getCredentialReports}
        getLookupCredentialReportData={getLookupCredentialReportData}
        getLookupCredentialReports={getLookupCredentialReports}
        PAGE_SIZES={PAGE_SIZES}
        handleAllGroupSearch={handleAllGroupSearch}
        isLoading={isLoading}
        location={location}
        clearDtaReports={clearDtaReports}
        getCredentialListData={getCredentialListData}
      />
      <ToastContainer />
    </>
  );
}

export default ReportCredentialCountConatiner;
